import { AccountObjectStoreFacade } from "../account-object/account-object.store-facade";
import { NotificationTemplate } from "./notification-template.model";
import { Qry } from "../query-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import * as actions from "../notification-template/notification-template.actions";
import { Observable } from "rxjs/Observable";

export class NotificationTemplateStoreFacade extends AccountObjectStoreFacade<NotificationTemplate> {

    getAll(): Observable<Array<NotificationTemplate>> {
        return this.select(Qry.getInstance().notificationTemplate.byActiveAccount);
    }

    create(notificationTemplate: NotificationTemplate): void {
        this.dispatch(new actions.SubmitAction(notificationTemplate));
    }

    update(notificationTemplate: NotificationTemplate): void {
        this.dispatch(new actions.SubmitAction(notificationTemplate));
    }

    insert(notificationTemplate: NotificationTemplate): void {
        this.dispatch(new actions.SubmitAction(notificationTemplate, {persistable: true, restful: false}));
    }

    remove(notificationTemplate: NotificationTemplate, options?: ActionOptionsArgs): void {
        this.dispatch(new actions.RemoveAction(notificationTemplate, options));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/notification-template/notification-template.store-facade.ts